import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentToken } from "./authSlice";
import { useRecordMenuActivityMutation } from "../logActivity/menuActivityApiSlice";

const MenuActivityTracker = () => {
  const location = useLocation();
  const token = useSelector(selectCurrentToken);
  const lastRecordedPath = useRef(null);
  const [recordMenuActivity] = useRecordMenuActivityMutation();

  useEffect(() => {
    if (!token || lastRecordedPath.current === location.pathname) return;
    lastRecordedPath.current = location.pathname;
    const pagePath = location.pathname
      .replace(/\/[0-9a-f-]{20,}(?=\/|$)/gi, "/:id")
      .replace(/\/\d+(?=\/|$)/g, "/:id");
    recordMenuActivity({ pagePath }).unwrap().catch(() => {});
  }, [location.pathname, recordMenuActivity, token]);

  return null;
};

export default MenuActivityTracker;